import $ from 'jquery';
import _ from 'underscore';
import { track } from 'util/analytics';
import {
    $body,
    $window,
    jqGetElemByCmpName,
    jqGetElemById,
    isMobile,
    userIsAuthenticated,
    jqOffOn,
    isBrilliantPremium,
} from 'util/global';
import { Anchors, crop } from 'util/ui';
import * as urls from 'util/urls';
import { INTERACTION_TYPES } from 'util/constants';
import { errorModalHandler } from 'app/error_modal';
import { initGenericControllers } from 'app/generic_controllers';
import { twinklingStars } from 'app/paid';
import 'waypoints/lib/noframework.waypoints';


const Practice = {};

/**
 * Practice subtopic controller.
 * @param {JQuery} $container
 */
Practice.subtopic = function ($container) {
    var data = $container.data();
    var $subtopics = $('.prac-subtopic');
    var $initialSubtopic = $subtopics.filter('.expanded');

    if ($initialSubtopic.length) {
        _.defer(function () {
            Anchors.scrollToTarget($initialSubtopic);
        });
    }

    $container.find('.prac-subtopic .trigger').on('click', function () {
        var $subtopic = $(this).parents('.prac-subtopic');
        $subtopic.toggleClass('expanded');

        if ($subtopic.hasClass('expanded')) {
            var subtopicSlug = $subtopic.data('subtopic-slug');
            var url = window.location.pathname + '?subtopic=' + subtopicSlug;
            var state = {
                subtopic: subtopicSlug
            };
            try {
                window.history.replaceState(state, '', url);
            } catch (e) {}

        } else {
            try {
                window.history.replaceState({}, '', window.location.pathname);
            } catch (e) {}
        }
    });
};


/**
 * Filters the chapter's view to quizzes or wikis
 * @param {JQuery} $container
 */
Practice.quizWikiFilter = function ($container) {
    var $btnGroup = $container.find('.btn-group, .btn-tabs'),
        $btns = $btnGroup.children(),
        activeClass = 'active',
        allTypes = '';

    $btns.each(function () {
        allTypes += $(this).data('type') + ' ';
    });

    $btns.on('click', function() {
        var $this = $(this),
            type = $this.data('type');

        if ( !$this.hasClass( activeClass ) ) {
            $btns.removeClass( activeClass );
            $this.addClass( activeClass );
            $container.removeClass( allTypes ).addClass( type );
        }
    });
};

/**
 * Track clicks on exploration topics and chapters coming soon
 * @param {JQuery} $trigger
 */
Practice.trackExplorationsComingSoon = function ($trigger) {
    var data = $trigger.data();
    var topicSlug = data.topicSlug;
    var chapterSlug = data.chapterSlug;
    var trackingElementId;
    var trackingTarget;

    if(topicSlug) {
        trackingElementId = 'clicked_exploration_topic_coming_soon';
        trackingTarget = topicSlug;
    } else {
        trackingElementId = 'clicked_exploration_chapter_coming_soon';
        trackingTarget = chapterSlug;
    }

    $trigger.on('click', () => {
        track('ui', {
            action: 'click',
            element_type: 'link',
            element_id: trackingElementId,
            target: trackingTarget,
        });
    });
};


/**
 * Masonry-style layout for the topic wiki listing section
 * @param {JQuery} $container
 */
Practice.wikiListing = function ($container) {
    _.defer(function () {
        var currentHeight = $container.height();
        while($container.width() < $container[0].scrollWidth || $container.height() < $container[0].scrollHeight) {
            currentHeight += 100;
            $container.css({
                height: currentHeight
            });
        }
    });
};

/**
 * Handle the course coming soon form
 * @param {JQuery} $container
 */
Practice.notifyComingSoon = function ($container) {
    var $form = $container.find('form');
    var submitting = false;

    var handleSubmit = function () {
        if (submitting === false) {
            submitting = true;
            $container.removeClass('with-form');
            $.post($form.prop('action'))
                .fail(errorModalHandler)
                .fail(() => {
                    submitting = false;
                    $container.addClass('with-form');
                });
        }
    };

    $form.on('submit', function (e) {
        e.preventDefault();
        handleSubmit();
    });

    $container.on('click', handleSubmit);
};

/**
 * Handle course card tracking and the scrollspy sidebar navigation on the course listing page
 * @param {JQuery} $container
 */
Practice.explorationsNav = function ($container) {
    // track course card clicks
    $container.find('.courses-item').on('click', function() {
        var $courseCard = $(this);
        var data = $courseCard.data();
        var eventParams = {
            action: 'click',
            element_id: 'clicked_course_card',
            nux_step: !!(urls.getParamsObject().tour),
            course_id: data.id,
            course_name: data.name,
            course_difficulty: data.difficulty,
            course_recommended: data.recommended,
            course_recent: data.recent,
            course_category: $courseCard.parents('.courses-category').find('.courses-category-name').text().trim(),
            course_category_number: $courseCard.parents('.courses-item-wrapper').index() + 1,
        };

        if (data.recommendedType) {
            eventParams.course_recommended_type = data.recommendedType;
        }

        track('ui', eventParams);
    });

    if (isMobile) {
        return;
    }

    var previousHash = null;
    const sidebarLinkSelector = $container.data('sidebarLinks') || '#nav-exploration-categories a';
    const $sidebarLinks = $(sidebarLinkSelector);

    var navHandler = function () {
        var $category = $(this);
        var currentHash = $category.data('category');
        var offset = $container.data('offset') || 40;

        if (previousHash) {
            $category.data('previous-category', previousHash);
        }

        previousHash = currentHash;

        const waypointHandler = (direction) => {
            const activeClass = 'active';
            let newHash;
            let newHref;

            if (direction === 'down') {
                newHash = $category.data('category');
                newHref = window.location.pathname + window.location.search + '#' + newHash;
            } else {
                newHash = $category.data('previous-category') || null;
                newHref = window.location.pathname + window.location.search;
                if (newHash) {
                    newHref += '#' + newHash;
                }
            }

            $sidebarLinks.removeClass('active');
            if (newHash) {
                const $subcategory = $sidebarLinks.filter('[data-subcategory=' + newHash + ']');
                if ($subcategory.length) {
                    $subcategory.addClass(activeClass);
                    $subcategory.parents('ul').siblings('a').addClass(activeClass);
                } else {
                    $sidebarLinks.filter('[data-category=' + newHash + ']').addClass(activeClass);
                }
            } else {
                jqGetElemById('exploration-sidebar-link').addClass(activeClass);
            }

            try {
                window.history.replaceState({}, '', newHref);
            } catch (e) {}
        };

        new Waypoint({
            element: this,
            offset: ($category.is(':last-child') ? 'bottom-in-view' : offset),
            handler: waypointHandler,
        });
    };

    _.defer(function() {
        $container.find('[data-category]').each(navHandler);
    });

    $sidebarLinks.on('click', (e) => {
        e.preventDefault();
        const $link = $(e.currentTarget);
        const callback = () => {
            // make links selected manually
            // (we need this hack because we don't add whitespace to the bottom of the page to make
            // the last course sections reachable by the top of the screen, so one or two
            // next-to-last section links can't be selected by Waypoints if those sections happen
            // to be in the middle of the page by the moment you scroll down to the very bottom)
            $sidebarLinks.removeClass('active');
            $link.addClass('active');
            // if it's a difficulty link, mark the higher level category link too
            $link.parents('ul').siblings('[data-category]').addClass('active');
            // if it's a category link, mark the first difficulty link underneath it, too
            $link.siblings('ul').find('[data-subcategory]').first().addClass('active');
        };
        Anchors.scrollToTarget($container.find(`#${$link[0].href.split('#')[1]}`), callback);
    });
};



/**
 * Share/actions menu for quiz problems and panes
 * @param {JQuery} $dropup
 */
Practice.quizSidebarDropup = ($dropup) => {
    const $quizSidebar = $('.course-quiz-sidebar');
    const $codexToggleBtns = $('.codex-expand-toggle');

    // make sure dropup is not overlapping with quiz content
    $dropup.on('open', () => {
        $codexToggleBtns.filter('.active').click();
        $quizSidebar.addClass('above-quiz-content');
    }).on('close', () => {
        $quizSidebar.removeClass('above-quiz-content');
    });
};


vkey.explorations_chapter_paywall = function (action, action_key) {
    vkey.handle(action, action_key);
};


/**
 * Handles the save for later button (looks like a bookmark)
 * @param {JQuery} $form - form that toggles if a solvable / pane has been saved
 */
Practice.saveForLater = ($form) => {
    const $button = $form.find('button');
    const $modal = $form.parent().find('#first-time-save-modal');

    const toggleButtonHover = () => {
        if ($button.hasClass('saved')) {
            $button.on('mouseenter', () => {
                $button.find('b').html('Remove');
            }).on('mouseleave', () => {
                $button.find('b').html('Saved');
            });
        } else {
            $button.off('mouseenter mouseleave');
        }
    };
    toggleButtonHover();
    $button.on('click', (e) => {
        e.preventDefault();
        $.post($form.attr('action'), $form.serialize(), (response) => {
            $button.toggleClass('saved');
            toggleButtonHover();
            if (response.saved) {
                $button.html('<b>Saved</b>');
                $form.prop('form_action').value = 'unsave';
            } else {
                $button.html('Save');
                $form.prop('form_action').value = 'save';
            }
            if (response.show_first_time_modal) {
                $modal.modal();
            }
        });
    })
};
module.exports = Practice;
